import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './ScrollStack.css';

const Card = ({ card, index, scrollYProgress, totalCards }) => {
  const isLast = index === totalCards - 1;
  const targetScale = isLast ? 1 : 1 - ((totalCards - index) * 0.05);
  const range = [index * 0.25, 1];
  
  const scale = useTransform(scrollYProgress, range, [1, targetScale]);

  return (
    <motion.div
      className="scroll-stack-card"
      style={{
        scale,
        top: `${index * 25}px`,
        zIndex: index + 1
      }}
    >
      {card}
    </motion.div>
  );
};

const ScrollStack = ({ cards = [] }) => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });

  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div ref={containerRef} className="scroll-stack-container">
      {cards.map((card, index) => (
        <Card 
          key={index}
          card={card}
          index={index}
          scrollYProgress={scrollYProgress}
          totalCards={cards.length}
        />
      ))}
    </div>
  );
};

export default ScrollStack;
